import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store/store';
import { selectFinalPDFs, selectFixedRange, setFixedRange } from '../pdf-slice';

require('./pdf-range-input.scss');

export const PDFFixedRangeComponent: React.FC<{}> = () => {
  const dispatch = useAppDispatch();

  const getSelectFixedRange = useSelector(selectFixedRange);
  const selectedPagesNumber = useSelector(selectFinalPDFs);

  return (
    <div className="pdf-tool-manage__right__split-fixed-ranges-container">
      <div className="pdf-range-input__title pdf-range-input__title--fixed">
        Fixed ranges
      </div>
      <div className="pdf-range-input__row pdf-range-input__row--no-border">
        <div className="pdf-range-input__text">Split in page ranges of:</div>
        <input
          type="number"
          className="pdf-range-input__input"
          min={1}
          defaultValue={getSelectFixedRange.toString()}
          onChange={(e) => dispatch(setFixedRange(parseInt(e.target.value)))}
        />
      </div>
      <div className="pdf-tool-manage__right__description pdf-tool-manage__right__description--down">
        Every selected range of this PDF file will be converted in one separated
        PDF file.
        <div className="pdf-tool-manage__right__files-text">
          <span className="pdf-tool-manage__right__bold">{`${selectedPagesNumber} PDF files`}</span>{' '}
          will be created.
        </div>
      </div>
    </div>
  );
};
